import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { Diaries } from "./StatsParts/Diaries";
import { Announcements } from "./StatsParts/Announcements";
import { IndividualMessagesHistory } from "./StatsParts/IndividualMessagesHistory";
import { Questionnaires } from "./StatsParts/Questionnaires";
import { AuthContext } from "../contexts/Auth/AuthContext";
import { staffCanAccessMenu } from "../config/menuAccessCatalog";

const QUESTIONNAIRES_TAB_INDEX = 3;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function StatsTabs() {
  const { user } = useContext(AuthContext);
  const canViewQuestionnaireStats = staffCanAccessMenu(user, "stats_questionnaires");
  const location = useLocation();
  const initialTab = location.state?.tabIndex ?? 0;
  const [value, setValue] = useState(initialTab);
  const [date, setDate] = useState(new Date());
  const [diariesFocused, setDiariesFocused] = useState(false);
  const isMobile = window.innerWidth <= 600;

  useEffect(() => {
    if (location.state?.tabIndex !== undefined) {
      setValue(location.state.tabIndex);
    }
  }, [location.state]);

  useEffect(() => {
    if (!canViewQuestionnaireStats && value === QUESTIONNAIRES_TAB_INDEX) {
      setValue(0);
    }
  }, [canViewQuestionnaireStats, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleDiariesTabFocus = () => {
    if (value !== 1) {
      setValue(1);
    } else {
      setDiariesFocused(true);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Estatísticas"
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons={isMobile ? "auto" : false}
          allowScrollButtonsMobile={isMobile}
          centered
        >
          <Tab label="Comunicados" {...a11yProps(0)} />
          <Tab
            label="Agendas"
            {...a11yProps(1)}
            onFocus={handleDiariesTabFocus}
          />
          <Tab label="Mensagens" {...a11yProps(2)} />
          {canViewQuestionnaireStats && (
            <Tab label="Questionários" {...a11yProps(QUESTIONNAIRES_TAB_INDEX)} />
          )}
          <Tab label="Financeiro" {...a11yProps(4)} disabled />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Announcements date={date} setDate={setDate} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Diaries date={date} setDate={setDate} focused={diariesFocused} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <IndividualMessagesHistory />
      </TabPanel>
      {canViewQuestionnaireStats && (
        <TabPanel value={value} index={QUESTIONNAIRES_TAB_INDEX}>
          <Questionnaires />
        </TabPanel>
      )}
      <TabPanel value={value} index={4}>
        Financeiro
      </TabPanel>
    </Box>
  );
}
